module.exports = __webpack_public_path__ + "static/img/13.2b40e78.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/1/zh/13.png
// module id = yGMU
// module chunks = 0